import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=0e78542c&scoped=true&"
import script from "./demo.vue?vue&type=script&lang=ts&"
export * from "./demo.vue?vue&type=script&lang=ts&"
import style0 from "./demo.vue?vue&type=style&index=0&id=0e78542c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e78542c",
  null
  
)

export default component.exports